import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state.js";
import { AnimatePresence, motion } from "framer-motion";

import SignupItemItemType from "./SignupItem/SignupItemItemType";
import SignupItemMembersType from "./SignupItem/SignupItemMembersType";
import SignupItemPollType from "./SignupItem/SignupItemPollType";
import usePrefectTwoFA from "./usePrefetchTwoFA";

export default function SignupItemsList({ isShowingPaymentUI }) {
  const location = useLocation();
  const [state, dispatch] = useSignups();
  const { signupItems } = state.currentSignupList;
  const signupListTypeID = state.currentSignupList.signupListVerbs.ID;
  usePrefectTwoFA();
  useEffect(() => {
    // Auto-expand a signup item based on the presence of a `signupItemID` query param

    if (signupListTypeID === 4) return; // do not auto-exand for polls, since they are single-click
    const urlParams = new URLSearchParams(location.search);
    const signupItemID = Number(urlParams.get("signupItemID"));
    if (!signupItemID) return;

    const itemExists = signupItems.find((item) => item.ID === signupItemID);
    if (itemExists) {
      dispatch({
        type: "expandedItemID",
        ID: signupItemID,
      });
    }
  }, [location.search, dispatch, signupItems, signupListTypeID]);

  const renderSignupItem = (signupItem) => {
    if (signupListTypeID === 4) {
      // Poll-type signup
      return <SignupItemPollType signupItem={signupItem} />;
    } else if (signupListTypeID === 5) {
      // Item-type signup
      return <SignupItemItemType signupItem={signupItem} />;
    }
    // Member-type signup (Event, seats, volunteers)
    return <SignupItemMembersType signupItem={signupItem} />;
  };

  const getSortedSignups = () => {
    return signupItems.sort((a, b) => (a.orderNumber > b.orderNumber ? 1 : -1));
  };

  return (
    <Wrapper $isShowingPaymentUI={isShowingPaymentUI}>
      <AnimatePresence>
        {getSortedSignups().map((signupItem, i) => (
          <motion.div
            key={signupItem.ID}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              type: "spring",
              delay: 0.3 + i * 0.1,
            }}
          >
            {renderSignupItem(signupItem)}
          </motion.div>
        ))}
      </AnimatePresence>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: ${({ $isShowingPaymentUI }) =>
    $isShowingPaymentUI ? "1rem" : 0};
`;